import { render, staticRenderFns } from "./ownerBatchInventory.vue?vue&type=template&id=336dabe5&scoped=true&"
import script from "./ownerBatchInventory.vue?vue&type=script&lang=tsx&"
export * from "./ownerBatchInventory.vue?vue&type=script&lang=tsx&"
import style0 from "./ownerBatchInventory.vue?vue&type=style&index=0&id=336dabe5&lang=scss&scoped=true&"
import style1 from "./ownerBatchInventory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336dabe5",
  null
  
)

export default component.exports